import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { MdOutlineKeyboardArrowRight } from "react-icons/md";
import Headers from "../components/Headers";
import Footer from "../components/Footer";
import toast from "react-hot-toast";
import { useNavigate, useLocation, useParams } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import {
  get_cart_products,
  delete_card_product,
  messageClear,
  quantity_inc,
  quantity_dec,
} from "../store/reducers/cardReducer";
import { fetchStoreBySlug } from "../store/reducers/homeReducer";
import { Button } from "../components/ui/button";
import { Minus, Package, Plus, ScrollText, Trash, MapPin } from "lucide-react";
import { Input } from "../components/ui/input";
import axios from "../api/api";
import { formatCurrency, fetchExchangeRates, convertCurrency } from "../utils/currencyUtils";
import { areStoreNamesEqual, normalizeStoreName } from "../utils/storeUtils";

const Card = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const { userInfo } = useSelector((state) => state.auth);
  const { seller } = useSelector((state) => state.home);
  const [shippingCountry, setShippingCountry] = useState("");
  const [currencyCode, setCurrencyCode] = useState("NGN");
  const [exchangeLoaded, setExchangeLoaded] = useState(false);
  const {
    card_products,
    successMessage,
    price,
    buy_product_item,
    outofstock_products,
  } = useSelector((state) => state.card);

  const { storeName: urlStoreName } = useParams();
  const storeToPass = urlStoreName || location.state?.fromStore;

  const filteredCardProducts = storeToPass
    ? card_products.filter(p => areStoreNamesEqual(p.shopName, storeToPass))
    : card_products;

  const calculateTotalPrice = () => {
    let total = 0;
    filteredCardProducts.forEach((group) => {
      group.products.forEach((pt) => {
        const { price, discount, currency } = pt.productInfo;
        const finalPrice = discount
          ? price - Math.floor((price * discount) / 100)
          : price;
        total += convertCurrency(finalPrice * pt.quantity, currencyCode, currency);
      });
    });
    return total;
  };

  const filteredPrice = calculateTotalPrice();

  const filteredItems = storeToPass
    ? filteredCardProducts.reduce((acc, group) => acc + group.products.reduce((pAcc, p) => pAcc + p.quantity, 0), 0)
    : buy_product_item;

  const redirect = () => {
    const shippingPath = storeToPass ? `/${storeToPass}/shipping` : "/shipping";
    navigate(shippingPath, {
      state: {
        products: filteredCardProducts,
        price: filteredPrice,
        items: filteredItems,
        fromStore: storeToPass
      },
    });
  };
  console.log(card_products)

  // Fetch user details (including shipping country) when the component mounts
  useEffect(() => {
    const fetchUserDetails = async () => {
      try {
        const { data } = await axios.get("/account/get-details", {
          withCredentials: true,
        });
        if (data.shippingDetails) {
          setShippingCountry(data.shippingDetails.country);
        }
      } catch (error) {
        // Handle error silently
      }
    };

    if (userInfo && userInfo.id) {
      fetchUserDetails();
      if (storeToPass) {
        dispatch(get_cart_products({ userId: userInfo.id, storeName: storeToPass }));
      } else {
        dispatch(get_cart_products(userInfo.id));
      }
    } else {
      // Guest user
      if (storeToPass) {
        dispatch(get_cart_products({ userId: null, storeName: storeToPass }));
      } else {
        dispatch(get_cart_products(null));
      }
    }
  }, [userInfo, dispatch, storeToPass]);

  useEffect(() => {
    if (storeToPass) {
      dispatch(fetchStoreBySlug(storeToPass));
    }
  }, [storeToPass, dispatch]);

  useEffect(() => {
    fetchExchangeRates().then(() => setExchangeLoaded(true));
  }, []);
  useEffect(() => {
    const fetchUserDetails = async () => {
      try {
        const { data } = await axios.get("/account/get-details", {
          withCredentials: true,
        });
        // if (data.currency) {
        //   setCurrencyCode(data.currency);
        // }
      } catch (error) {
        // Handle error silently
      }
    };

    if (userInfo && userInfo.id) {
      fetchUserDetails();
    }
  }, []);

  useEffect(() => {
    if (successMessage) {
      // toast.success(successMessage);
      dispatch(messageClear());
      if (storeToPass) {
        dispatch(get_cart_products({ userId: userInfo ? userInfo.id : null, storeName: storeToPass }));
      } else {
        dispatch(get_cart_products(userInfo ? userInfo.id : null));
      }
    }
  }, [successMessage, userInfo, dispatch, storeToPass]);

  const inc = (quantity, stock, card_id) => {
    const temp = quantity + 1;
    if (stock && temp <= stock) {
      dispatch(quantity_inc({ card_id, storeName: storeToPass }));
    }
  };

  const dec = (quantity, card_id) => {
    const temp = quantity - 1;
    if (temp > 0) {
      dispatch(quantity_dec({ card_id, storeName: storeToPass }));
    }
  };

  // Function to check if a product ships to the user's country
  const shipsToUserCountry = (product) => {
    if (!shippingCountry) return false; // If no country is set, return false
    const shippingPrices = product.productInfo.shippingPrices || {};
    return Object.keys(shippingPrices).includes(shippingCountry); // Check if the user's country is in the shipping locations
  };

  // Scroll to top when component mounts
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const getThemeClass = () => {
    const themeSettings = seller?.themeSettings;
    const useCustomTheme = themeSettings?.useCustomTheme;

    // Custom theme always uses light-theme class (defaults to light colors)
    if (useCustomTheme) {
      return 'light-theme';
    }
    if (seller?.shopInfo?.theme === 'light') {
      return 'light-theme';
    }
    if (storeToPass) {
      const normalizedStore = normalizeStoreName(storeToPass);
      const cachedTheme = localStorage.getItem(`store-theme-${normalizedStore}`);
      if (cachedTheme === 'light') return 'light-theme';

      try {
        const cachedSettings = localStorage.getItem(`store-settings-${normalizedStore}`);
        if (cachedSettings) {
          const settings = JSON.parse(cachedSettings);
          if (settings.useCustomTheme) return 'light-theme';
        }
      } catch (e) { }
    }
    return '';
  };
  const themeClass = getThemeClass();

  // Apply theme class to body immediately on render if we have cached theme context
  if (themeClass === 'light-theme') {
    document.body.classList.add('light-theme');

    // If we have cached custom theme settings, apply them now to prevent flash
    if (storeToPass) {
      try {
        const normalizedStore = normalizeStoreName(storeToPass);
        const cachedSettings = localStorage.getItem(`store-settings-${normalizedStore}`);
        if (cachedSettings) {
          const settings = JSON.parse(cachedSettings);
          if (settings.useCustomTheme) {
            const colors = settings.colors || {};
            const setVar = (name, value) => {
              if (value) document.body.style.setProperty(name, value);
            };
            const getContrastColor = (hexcolor) => {
              if (!hexcolor || hexcolor === 'transparent') return null;
              const hex = hexcolor.replace('#', '');
              const r = parseInt(hex.slice(0, 2), 16);
              const g = parseInt(hex.slice(2, 4), 16);
              const b = parseInt(hex.slice(4, 6), 16);
              const yiq = ((r * 299) + (g * 587) + (b * 114)) / 1000;
              return (yiq >= 128) ? '#000000' : '#ffffff';
            };
            const contrastColor = getContrastColor(colors.background);
            setVar('--store-bg', colors.background);
            setVar('--store-text', contrastColor);
            setVar('--store-icon', contrastColor);
            setVar('--store-button-bg', colors.buttonBg);
            setVar('--store-button-text', colors.buttonText);
            setVar('--store-product-card-bg', colors.productCardBg);
            setVar('--store-header-bg', colors.headerBg);
            setVar('--store-footer-bg', colors.footerBg);
            setVar('--store-border', colors.border);
            if (settings.typography?.fontFamily) {
              const fontFamily = settings.typography.fontFamily;
              const fontId = `google-font-${fontFamily.replace(/\s+/g, '-')}`;
              if (!document.getElementById(fontId)) {
                const link = document.createElement('link');
                link.id = fontId;
                link.rel = 'stylesheet';
                link.href = `https://fonts.googleapis.com/css2?family=${encodeURIComponent(fontFamily)}:wght@300;400;500;600;700&display=swap`;
                document.head.appendChild(link);
              }
              setVar('--store-font-family', `"${fontFamily}", sans-serif`);
            }
          }
        }
      } catch (e) {
        console.error("Error applying cached theme:", e);
      }
    }
  }

  useEffect(() => {
    if (seller?.shopInfo && storeToPass) {
      const normalizedStore = normalizeStoreName(storeToPass);
      localStorage.setItem(`store-theme-${normalizedStore}`, seller.shopInfo.theme);
      localStorage.setItem(`store-settings-${normalizedStore}`, JSON.stringify(seller.themeSettings || {}));

      const themeSettings = seller?.themeSettings;
      const useCustomTheme = themeSettings?.useCustomTheme;

      // Apply light-theme class when using custom theme or when theme is 'light'
      if (useCustomTheme || seller.shopInfo.theme === 'light') {
        document.body.classList.add('light-theme');
      } else {
        document.body.classList.remove('light-theme');
      }

      // Apply custom CSS variables when useCustomTheme is true
      if (useCustomTheme && themeSettings) {
        const colors = themeSettings.colors || {};
        const setVar = (name, value) => {
          if (value) document.body.style.setProperty(name, value);
        };

        const getContrastColor = (hexcolor) => {
          if (!hexcolor || hexcolor === 'transparent') return null;
          const hex = hexcolor.replace('#', '');
          const r = parseInt(hex.slice(0, 2), 16);
          const g = parseInt(hex.slice(2, 4), 16);
          const b = parseInt(hex.slice(4, 6), 16);
          const yiq = ((r * 299) + (g * 587) + (b * 114)) / 1000;
          return (yiq >= 128) ? '#000000' : '#ffffff';
        };

        setVar('--store-bg', colors.background);
        const contrastColor = getContrastColor(colors.background);
        setVar('--store-text', contrastColor);
        setVar('--store-icon', contrastColor);
        setVar('--store-button-bg', colors.buttonBg);
        setVar('--store-button-text', colors.buttonText);
        setVar('--store-product-card-bg', colors.productCardBg);
        setVar('--store-header-bg', colors.headerBg);
        setVar('--store-footer-bg', colors.footerBg);
        setVar('--store-input-bg', themeSettings.inputs?.background || colors.inputBg);
        setVar('--store-input-text', themeSettings.inputs?.text || colors.inputText);
        setVar('--store-input-border', themeSettings.inputs?.border || colors.inputBorder);
        setVar('--store-input-focus', themeSettings.inputs?.focusRing || '#000000');
        setVar('--store-input-radius', `${themeSettings.inputs?.radius || 20}px`);
        setVar('--store-select-bg', themeSettings.selects?.background || colors.inputBg);
        setVar('--store-select-text', themeSettings.selects?.text || colors.inputText);
        setVar('--store-select-border', themeSettings.selects?.border || colors.inputBorder);
        setVar('--store-select-focus', themeSettings.selects?.focusRing || '#000000');
        setVar('--store-select-radius', `${themeSettings.selects?.radius || 20}px`);
        setVar('--store-border', colors.border);
        setVar('--store-muted', colors.muted);
        setVar('--store-glass', colors.glass);

        // Load and apply Google Font
        if (themeSettings.typography?.fontFamily) {
          const fontFamily = themeSettings.typography.fontFamily;
          const fontId = `google-font-${fontFamily.replace(/\s+/g, '-')}`;

          if (!document.getElementById(fontId)) {
            const link = document.createElement('link');
            link.id = fontId;
            link.rel = 'stylesheet';
            link.href = `https://fonts.googleapis.com/css2?family=${encodeURIComponent(fontFamily)}:wght@300;400;500;600;700&display=swap`;
            document.head.appendChild(link);
          }

          setVar('--store-font-family', `"${fontFamily}", sans-serif`);
          document.body.style.fontFamily = `"${fontFamily}", sans-serif`;
        }
      }
    }

    // Cleanup when unmounting or changing stores
    return () => {
      // document.body.classList.remove('light-theme'); // Handled by StoreLayout
    };
  }, [seller, storeToPass]);

  const isStoreMode = !!urlStoreName;

  return (
    <div className={`min-h-screen bg-[var(--store-bg)] transition-colors duration-300 ${!isStoreMode ? themeClass : ''}`}>
      {!isStoreMode && <Headers />}
      <section
        className="h-[220px] bg-cover bg-no-repeat relative bg-left bg-[var(--store-bg)]"
        style={{
          backgroundImage: themeClass === 'light-theme' ? 'none' : `url(${process.env.REACT_APP_URL}/images/banner/cartnew.jpg)`,
        }}
      >
        <div className={`absolute left-0 top-0 w-full h-full transition-colors duration-500 ${themeClass === 'light-theme' ? 'bg-[#0000004d]' : 'bg-[#0000008a]'}`}>
          <div className="w-[85%] md:w-[80%] sm:w-[90%] lg:w-[90%] h-full mx-auto">
            <div className="flex flex-col justify-center gap-1 items-center h-full w-full text-white">
              <h2 className="text-3xl font-bold">Stores</h2>
              <div className="flex justify-center items-center gap-2 text-2xl w-full">
                <Link to={location.state?.fromStore ? `/${location.state.fromStore}` : "/"}>Home</Link>
                <span className="pt-2">
                  <MdOutlineKeyboardArrowRight />
                </span>
                <span>Cart</span>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="bg-[var(--store-bg)]">
        <div className="w-[85%] lg:w-[90%] md:w-[90%] sm:w-[90] mx-auto py-16">
          {filteredCardProducts.length > 0 || outofstock_products.length > 0 ? (
            <div className="flex flex-wrap">
              {/* Product List */}
              <div className="w-[67%] md-lg:w-full">
                <div className="pr-3 md-lg:pr-0">
                  <div className="flex flex-col gap-3">
                    {filteredCardProducts.map((p, shopIndex) => (
                      <div
                        key={shopIndex}
                        className="flex bg-[var(--store-product-card-bg)] p-4 flex-col gap-5"
                      >
                        <div className="flex justify-start items-center">
                          <Link to={`/${p.shopName}`} className="text-md text-[var(--store-text)] flex items-center hover:text-green-500 transition-colors">
                            {p.shopName} <Package size={18} className="ml-2" />
                          </Link>
                        </div>
                        {p.products.map((pt, productIndex) => (
                          <div
                            key={productIndex}
                            className="w-full flex flex-wrap"
                          >
                            <div className="flex sm:w-full gap-2 w-7/12">
                              <div className="flex gap-2 justify-start items-center">
                                <img
                                  className="w-[80px] h-[80px] nex_img_cover rounded-md"
                                  src={pt.productInfo.images[0]}
                                  alt="product"
                                />
                                <div className="px-2 text-[var(--store-text)]">
                                  <h2 className="text-md">
                                    {pt.productInfo.name}
                                  </h2>
                                  <span className="text-sm">
                                    Brand : {pt.productInfo.brand}
                                  </span>
                                  {/* Display shipping info */}
                                  {shippingCountry && (
                                    <div
                                      className={`flex items-center gap-1 mt-1 p-1 rounded ${shipsToUserCountry(pt)
                                        ? "bg-green-500/20 text-green-500"
                                        : "bg-red-500/20 text-red-500"
                                        }`}
                                    >
                                      <MapPin className="h-4 w-4" />
                                      <span className="text-sm">
                                        {shipsToUserCountry(pt)
                                          ? `Ships to ${shippingCountry}`
                                          : `Does not ship to ${shippingCountry}`}
                                      </span>
                                    </div>
                                  )}
                                </div>
                              </div>
                            </div>
                            <div className="flex justify-between w-5/12 sm:w-full sm:mt-3">
                              <div className="pl-4 sm:pl-0 flex flex-col gap-2">
                                <h2 className="text-lg text-green-500">
                                  {" "}
                                  {formatCurrency(
                                    pt.productInfo.discount
                                      ? pt.productInfo.price -
                                      Math.floor(
                                        (pt.productInfo.price *
                                          pt.productInfo.discount) /
                                        100
                                      )
                                      : pt.productInfo.price,
                                    currencyCode,
                                    pt.productInfo.currency
                                  )}
                                </h2>
                                <p className="text-[var(--store-text)]">
                                  {formatCurrency(
                                    pt.productInfo.price,
                                    currencyCode,
                                    pt.productInfo.currency
                                  )}
                                </p>
                                <p className="text-sm text-[var(--store-text)]">
                                  {pt.productInfo.discount
                                    ? `-${pt.productInfo.discount}%`
                                    : ""}
                                </p>
                              </div>

                              <div className="flex gap-2 flex-col">
                                <div className="flex bg-[var(--store-card-bg)] h-[35px] justify-center items-center px-5 rounded-full text-xl text-[var(--store-text)]">
                                  <div
                                    onClick={() => dec(pt.quantity, pt._id)}
                                    className="px-3 cursor-pointer"
                                  >
                                    <Minus size={18} />
                                  </div>
                                  <div className="px-3 text-[14px]">
                                    {pt.quantity}
                                  </div>
                                  <div
                                    onClick={() =>
                                      inc(
                                        pt.quantity,
                                        pt.productInfo.stock,
                                        pt._id
                                      )
                                    }
                                    className="px-3 cursor-pointer"
                                  >
                                    <Plus size={18} />
                                  </div>
                                </div>
                                <Button
                                  onClick={() =>
                                    dispatch(delete_card_product({ card_id: pt._id, storeName: storeToPass }))
                                  }
                                  className="px-5 bg-red-600 text-white hover:bg-red-500"
                                >
                                  Delete{" "}
                                </Button>
                              </div>
                            </div>
                          </div>
                        ))}
                      </div>
                    ))}

                    {outofstock_products.length > 0 && (
                      <div className="flex flex-col gap-3">
                        <div className="bg-[var(--store-product-card-bg)] p-4">
                          <h2 className="text-md text-red-500 font-semibold">
                            Out of stock {outofstock_products.length}
                          </h2>
                        </div>
                        <div className="bg-[var(--store-product-card-bg)] p-4">
                          {outofstock_products.map((p, index) => (
                            <div key={index} className="w-full flex flex-wrap">
                              <div className="flex sm:w-full gap-2 w-7/12">
                                <div className="flex gap-2 justify-start items-center">
                                  <img
                                    className="w-[80px] h-[80px] nex_img_cover rounded-sm"
                                    src={p.products[0].images[0]}
                                    alt="product"
                                  />
                                  <div className="px-2 text-[var(--store-text)]">
                                    <h2 className="text-md">
                                      {p.products[0].name}
                                    </h2>
                                    <span className="text-sm">
                                      Brand : {p.products[0].brand}
                                    </span>
                                  </div>
                                </div>
                              </div>
                              <div className="flex justify-between w-5/12 sm:w-full sm:mt-3">
                                <div className="pl-4 sm:pl-0 flex flex-col gap-2">
                                  <h2 className="text-lg text-green-500">
                                    $
                                    {p.products[0].price -
                                      Math.floor(
                                        (p.products[0].price *
                                          p.products[0].discount) /
                                        100
                                      )}
                                  </h2>
                                  <p className="text-[var(--store-text)]">
                                    {p.products[0].price}
                                  </p>
                                  <p className="text-sm text-[var(--store-text)]">
                                    -{p.products[0].discount}%
                                  </p>
                                </div>
                                <div className="flex gap-2 flex-col">
                                  <div className="flex bg-[var(--store-card-bg)] h-[35px] justify-center items-center px-5 rounded-full text-xl text-[var(--store-text)]">
                                    <div
                                      onClick={() => dec(p.quantity, p._id)}
                                      className="px-3 cursor-pointer"
                                    >
                                      <Minus size={18} />
                                    </div>
                                    <div className="px-3 text-[14px]">
                                      {p.quantity}
                                    </div>
                                    <div
                                      onClick={() =>
                                        inc(
                                          p.quantity,
                                          p.products[0].stock,
                                          p._id
                                        )
                                      }
                                      className="px-3 cursor-pointer"
                                    >
                                      <Plus size={18} />
                                    </div>
                                  </div>
                                  <Button
                                    onClick={() =>
                                      dispatch(delete_card_product(p._id))
                                    }
                                    className="px-5 py-[3px] bg-red-600 hover:text-white hover:bg-red-500 text-white"
                                  >
                                    Delete
                                  </Button>
                                </div>
                              </div>
                            </div>
                          ))}
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              </div>
              <div className="w-[33%] md-lg:w-full">
                <div className="pl-3 md-lg:pl-0 md-lg:mt-5">
                  {filteredCardProducts.length > 0 && (
                    <div className="bg-[var(--store-product-card-bg)] p-3 text-[var(--store-text)] flex flex-col gap-8">
                      <h2 className="text-xl font-bold flex items-center">
                        Order summary <ScrollText className="ml-2" />
                      </h2>
                      <div className="flex justify-between items-center">
                        <span>{filteredItems} Items</span>
                        <span className="text-green-500"> {formatCurrency(filteredPrice, currencyCode, currencyCode)}</span>
                      </div>
                      <div className="flex justify-between items-center">
                        <span>Total</span>
                        <span className="text-lg text-[var(--store-text)]">{formatCurrency(filteredPrice, currencyCode, currencyCode)}</span>
                      </div>
                      <Button
                        onClick={redirect}
                        className="px-5 py-[6px] rounded-full bg-[var(--store-button-bg)] text-[var(--store-button-text)] hover:bg-[var(--store-button-bg)] hover:opacity-90"
                      >
                        Proceed to checkout
                      </Button>
                    </div>
                  )}
                </div>
              </div>
            </div>
          ) : (
            <div className="flex flex-col items-center gap-4 text-[var(--store-text)]">
              <p>You have no items in your cart.</p>
              <Link to={location.state?.fromStore ? `/${location.state.fromStore}` : "/stores"}>
                <Button className="bg-[var(--store-button-bg)] text-[var(--store-button-text)] hover:bg-[var(--store-button-bg)] hover:opacity-90">Shop Now</Button>
              </Link>
            </div>
          )}
        </div>
      </section>
      {!isStoreMode && <Footer />}
    </div>
  );
};

export default Card;
